import axios from "axios";
import { completeSsoRedirect } from "./configuration";
import { deleteAllCookies } from "./helpers/deleteAllCookies";
import { getCookieByName } from "./helpers/getCookieByName";

axios.interceptors.request.use(
  function (config) {
    const token = getCookieByName();
    config.headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      Authorization: "Bearer " + token,
    };

    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    if(response.status === 202 && response.config.url.endsWith('check-credentials')) {
      const currentSite = window.location.origin;
      const data = response.data;

      const siteRol = data.user.roles.find(item => item.USER_SITE_URL === currentSite);
      if(siteRol){
        localStorage.removeItem('log-ged');
        localStorage.setItem('rol', siteRol.USER_SITE_ROL || '');
      }

      if(!siteRol || !siteRol.USER_SITE_ROL){
        localStorage.setItem('log-ged', 'not-logged');
        localStorage.setItem('rol', '');
        window.location.href = "/unauthorized";
      }
    }

    return response;
  },

  function (error) {
    if (error.response.data.statusCode === 401) {
      if (error.response.data.message === "Unauthorized") {
        deleteAllCookies();
        window.location.href = completeSsoRedirect;
      }
    }
    return Promise.reject(error);
  }
);
